export default __webpack_public_path__ + "static/media/secti.b467d91d.svg";